<template>
  <div class="year-main-content">
    <div class="year-top-image" v-bind:style="{ backgroundImage: 'url(' + require('@/assets/' + topImage) + ')' }">
    <div class="year-overlay"><span>2011</span></div>
    </div>
    <div class="view-wrap yr2011">


<FullYearStats fullGames='16' fullCompletions='468' fullAttempts='657' fullYards='5,476' fullPct='71.2' fullTDs='46' fullINTs='14' fullYPG='342.3' fullRating='110.6'></FullYearStats>

  <div class="year-summary-wrapper">
    <div class="triangle-top-left"></div>
    <div class="triangle-bottom-right"></div>
    <div class="year-summary">
    

      <div class="year-summary-text-flex">

      <h1 class="content-headline">A dominant season rewrites the record books</h1>

      <div class="copy-paragraph">
        Brees led the Saints to their third straight playoff appearance in 2011, as he completed 468-of-657 passes (71.2%) for 5,476 yards with 46 touchdown passes and a 110.6 passer rating. He was voted the Associated Press NFL Offensive Player of the Year.<br/><br/>

        In addition to his NFL records in completions, completion percentage and passing yardage, he also ranked first in the league in attempts, third down passer rating (127.4) and second in touchdown passes and passer rating.<br/><br/>

        On the back of a legendary season from Brees and the Saints offense, New Orleans won their last eight games to finish 13-3. The Saints would go on to score 45 points the next week in a Wild Card Round victory over the visiting Detroit Lions. Unfortunately, a third NFC Championship appearance would once again elude the Saints as they lost a heartbreaker the following week at San Francisco in the Divisonal Round.
        <br/><br/>

        Brees ended 2011 riding a streak of 43 consecutive games with at least one touchdown pass, second in NFL records behind Johnny Unitas (47).
        
      </div>

      <div class="copy-paragraph">
      <img :src="require('@/assets/brees-2011-img-in-copy.jpg')" style="width:100%;" alt="Drew Brees runs off the field after one of his record breaking performances">
      </div>


<div class="awards-wrapper">
        <div class="awards-headline">2011 Awards</div>
        <ul>

          <li><img :src="require('@/assets/pro-bowl.png')" alt="Pro Bowl Logo"> 2011 Pro Bowl</li>
          <li><img :src="require('@/assets/nfl-logo.svg')" alt="NFL Logo"> 1st Team All-Pro (SI / Peter King)</li>
          <li><img :src="require('@/assets/nfl-logo.svg')" alt="NFL Logo"> 2nd Team All-Pro (AP, PFF)</li>
          <li><img :src="require('@/assets/si-award.jpg')" alt="Sports Illustrated Logo"> NFL Offensive Player of the Year (SI / Peter King)</li>
          <li><img :src="require('@/assets/ap-award.jpg')" alt="AP Logo"> NFL Offensive Player of the Year (AP)</li>
          <li><img :src="require('@/assets/fedex-air.jpg')" alt="FedEx Logo"> FedEx Air Player of the Year</li>
          <li><img :src="require('@/assets/101-award.png')" alt="101 Awards Logo"> Committee of 101 NFC Offensive Player of the Year</li>
          <li><img :src="require('@/assets/bart-starr.png')" alt="Bart Starr Logo"> Bart Starr Award</li>
          
          
          
        </ul>
        <div class="awards-legend">
<b>AP</b> - Associated Press, <b>CN</b> - College & Pro Football Weekly, <b>FD</b> -Football Digest, <b>FN</b> -Football News, <b>FW</b> - Professional Football Writers of America, <b>NE</b> - Newspaper Enterprise Association, <b>NY</b> - New York Daily News, <b>PFWA</b> - Pro Football Writers of America, <b>PW</b> - Pro Football Weekly(1992-2012,choices combined with Pro Football Writers of America), <b>SI</b> - Sports Illustrated, <b>SN</b> - Sporting News, <b>UP</b> - United Press International, <b>UW</b> - USA Today/Sports Weekly
        </div>
      </div> 

      </div> <!--end text-flex-->
    </div>
  </div>


 <div class="bubble-chart-wrapper chart-light">
      <h2 class="chart-headline">2011 Top Rated Passers</h2>
      <BubbleChart :chart-data="dataBubble1" :options="dataOptions3" style="height:400px;"></BubbleChart>
</div>



<div class="touchdowns-header-wrapper">
  <h1><img src="https://nolaprodigital.com/saints/brees500/images/referee-icon-white.png" alt="Drew Brees 2011 Touchdown Tally"> 2011 TOUCHDOWN TALLY</h1>
</div>




</div>


<TDsByYear :tds="this.tds"></TDsByYear>



<flickity ref="flickity" :options="flickityOptions">
  <div class="carousel-cell"><img :src="require('@/assets/' + image1)" alt="Drew Brees in 2011 - Slide1"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image2)" alt="Drew Brees in 2011 - Slide2"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image3)" alt="Drew Brees in 2011 - Slide3"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image4)" alt="Drew Brees in 2011 - Slide4"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image5)" alt="Drew Brees in 2011 - Slide5"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image6)" alt="Drew Brees in 2011 - Slide6"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image7)" alt="Drew Brees in 2011 - Slide7"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image8)" alt="Drew Brees in 2011 - Slide8"></div>
</flickity>


<div class="year-pagination-wrapper">
  <div class="year-pagination-section year-pagination-prev"><router-link to="/year/2010">«2010</router-link></div>
  <div class="year-pagination-section year-pagination-current">2011</div>
  <div class="year-pagination-section year-pagination-next"><router-link to="/year/2012">2012»</router-link></div>
</div>



    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import StatsFlex from '@/components/StatsFlex.vue'
import Flickity from 'vue-flickity';
import VideoBtn from '@/components/VideoBtn.vue';
import FullYearStats from '@/components/FullYearStats.vue';
import TDsByYear from '@/components/TDsByYear.vue';
import BubbleChart from '@/components/BubbleChart.vue';

import axios from 'axios';

export default {
  name: 'yr2011',
  components: {
    Flickity,
    StatsFlex,
    VideoBtn,
    FullYearStats,
    TDsByYear,
    BubbleChart
  },
  metaInfo: {
    title: 'Drew Brees Stats and Touchdowns from his 2011 season',
    htmlAttrs: {
      lang: 'en'
    }
  },
  data() {
    return {
      tds: {},
      loading: false,
      games: [],
      topImage: "brees-2011-top.jpg",
      image1: "brees-2011-slide-1.jpg",
      image2: "brees-2011-slide-2.jpg",
      image3: "brees-2011-slide-3.jpg",
      image4: "brees-2011-slide-4.jpg",
      image5: "brees-2011-slide-5.jpg",
      image6: "brees-2011-slide-6.jpg",
      image7: "brees-2011-slide-7.jpg",
      image8: "brees-2011-slide-8.jpg",

      flickityOptions: {
            initialIndex: 0,
            prevNextButtons: false,
            pageDots: false,
            resize: true,
            wrapAround: true,
            autoPlay: true

            // any options from Flickity can be used
            }

          } 
        },
  methods: {
    async getTDs() {
      const self = this;
      const response = await axios.get(
        "../../static/td-data.json"
      );
      this.tds = response.data.y2011;
      console.log(this.tds)
    },
    next() {
      this.$refs.flickity.next();
    },

    previous() {
      this.$refs.flickity.previous();
    },
    resize() {
      this.$refs.flickity.resize();
    }
  },

  mounted: function() {
    this.getTDs();

    setTimeout(() => {
    this.$refs.flickity.resize();
    }, 2000)

  },

created() {

      

       this.dataBubble1 = {
      "datasets": [
      {
        "label": "Drew Brees",
        "backgroundColor": "#101820",
        "borderColor": "#D3BC8D",
        "fill": false,
        "pointBackgroundColor": '#D3BC8D',
        "pointColor": "#D3BC8D",
        
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#D3BC8D",
        data: [
                {
                  x: 71.2,
                  y: 5476,
                  r: 46/1.5
                }
              ]
      },
      {
        "label": "Tom Brady",
        "backgroundColor": "#002244",
        "borderColor": "#C60C30",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 65.6,
                  y: 5235,
                  r: 39/1.5
                }
              ]
      },
      {
        "label": "Matt Stafford",
        "backgroundColor": "#B0B7BC",
        "borderColor": "#0076B6",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 63.5,
                  y: 5038,
                  r: 41/1.5
                }
              ]
      },
      {
        "label": "Aaron Rodgers",
        "backgroundColor": "#203731",
        "borderColor": "#FFB612",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 68.3,
                  y: 4643,
                  r: 45/1.5
                }
              ]
      },
       {
        "label": "Tony Romo",
        "backgroundColor": "#041E42",
        "borderColor": "#869397",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 66.3,
                  y: 4184,
                  r: 31/1.5
                }
              ]
      }
      ]
    },
    this.dataOptions3 = {
        "responsive": true,
        "maintainAspectRatio": false,
        title: {
            display: true,
            text: '(Bubble size is Touchdowns)'
        },
        "layout": {
          padding: {
                left: 10,
                right: 10,
                top: 0,
                bottom: 0
          },
        },
        "legend": {
          "position" : "bottom",
            "maxSize" : {
                "height" : 400
            },
            "labels": {
                "fontColor": "black",
                "fontSize": 14,
                "usePointStyle" : true
            }
        },
        tooltips: {
          "mode": "point",
          callbacks: {
              label: function(tooltipItem, data) {
                 var rLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].r;
                  var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
                  return datasetLabel + ' : ' + tooltipItem.yLabel.toLocaleString() + ' Yards, ' + tooltipItem.xLabel.toLocaleString() + ' Completion %, ' + rLabel*1.5 + ' TDs';
              }
          }
        },
        "scales": {
          "yAxes": [{
            scaleLabel: {
              display: true,
              labelString: 'Yards'
            },
            gridLines: {
              color: '#D3BC8D',
              tickMarkLength: 20,
              lineWidth: .2
                },
            "ticks": {
              "fontColor": 'black',
              callback: function(value, index, values) {
                        return value.toLocaleString();
                    },
            },
          }],
          "xAxes": [{
            scaleLabel: {
              display: true,
              labelString: 'Completion Percentage'
            },
            gridLines: {
              color: '#D3BC8D',
              tickMarkLength: 20,
              lineWidth: .2
            },
            "ticks": {
              
              "fontColor": 'black'
            },
          }]
        }
    }

    }
}
</script>

<style>

.year-top-image > img {
  width:100%;
}


@media (max-width:767px;) {
  .year-main-content {
  margin-top:35px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/yr2011.vue